module.exports = __webpack_public_path__ + "static/media/cert_158.05fb9a5b.jpg";